<template>
  <v-col class="home" align-center>
    <v-stepper v-model="activeStep" class="stepper" :non-linear="true" @change="onStepChange">
      <v-stepper-header class="stepper-header elevation-3">
        <v-stepper-step :complete="activeStep > 1" step="1" editable>{{ $t("ORDER_STEP_1") }}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="activeStep > 2" step="2" :editable="allowStep2And3" edit-icon="photo_library">
          {{ $t("ORDER_STEP_2") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="activeStep > 3" step="3" :editable="allowStep2And3">
          {{ $t("ORDER_STEP_3") }}
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <CodeSubmission/>
        </v-stepper-content>

        <v-stepper-content step="2">
          <ImagePresentation ref="imagePresentation"/>
        </v-stepper-content>

        <v-stepper-content step="3">
          <Products/>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-col>
</template>

<script lang="ts">
import Component from "vue-class-component";
import CodeSubmission from "@/views/CodeSubmission.vue";
import ImagePresentation from '@/views/ImagePresentation.vue';
import Products from "@/views/Products.vue";
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {CodeSubmission, Products, ImagePresentation}
})
export default class Home extends BasicComponent {

  code: string = "";
  loading: boolean = false;

  created() {

  }

  mounted() {

  }

  get activeStep() {
    return this.$route.query.step;
  }

  set activeStep(val) {
    this.setStep(val);
  }

  onStepChange(step) {
    if (step !== '1') {
      this.removeCodesFromQueryParams()
    }
  }

  get allowStep2And3() {
    const modifiedCodes = this.$store.getters.step === '1' && !this.codesInputMatchesSelection
    return this.hasImages && !modifiedCodes
  }

}
</script>
<style scoped lang="scss">

@use "../stylesheets/Variables.scss";

.home {
  width: 100%;

}
</style>

<style lang="scss">
.home {

  .stepper {

    min-height: 100%;
    box-shadow: none !important;
    background-color: transparent !important;

    .stepper-header {
      background-color: white !important;
      margin: 5px !important;
    }

    .v-stepper__content {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .v-stepper, .v-stepper__items, .v-stepper__content, .v-stepper__wrapper {
    overflow: visible !important;
  }
}
</style>
